import * as React from 'react';
import { TModals } from './Modals.types';
import { observer } from 'mobx-react-lite';
import Backdrop from '@mui/material/Backdrop';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import './Modals.styled.scss';
import classNames from 'classnames';
import { useModals } from 'hooks/useModals';
import { TModalConfigItem } from 'store/contexts/ModalContext/ModalContext.types';
import { MODAL_CONFIGS, MODAL_TYPES } from 'store/contexts/ModalContext/modals';
import { IconButton } from 'components';
import { Close } from '@mui/icons-material';
import { ModalFooter } from './components/ModalFooter/ModalFooter';

export const Modals: TModals = observer(() => {
  const modalsControl = useModals();
  const ModalConfig: TModalConfigItem = MODAL_CONFIGS[modalsControl.name];
  const footerProps = modalsControl.footerProps || {};

  const modalClassname = classNames('modal', {
    'modal--regular': ModalConfig?.type === MODAL_TYPES.REGULAR,
    'modal--small': ModalConfig?.type === MODAL_TYPES.SMALL,
    'modal--large': ModalConfig?.type === MODAL_TYPES.LARGE,
  });

  return (
    <Modal
      open={modalsControl.isOpen}
      onClose={modalsControl.closeModal}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
    >
      <Fade in={modalsControl.isOpen}>
        <div className={modalClassname}>
          {ModalConfig?.title && (
            <div className="modal__header">
              <h4>{ModalConfig?.title}</h4>
              <IconButton onClick={modalsControl.closeModal}>
                <Close color="primary" fontSize="large" />
              </IconButton>
            </div>
          )}
          <div className="modal__content">
            {ModalConfig?.Component ? (
              <ModalConfig.Component
                {...(modalsControl.modalProps || {})}
                closeModal={modalsControl.closeModal}
              />
            ) : null}
          </div>
          <ModalFooter {...footerProps} />
        </div>
      </Fade>
    </Modal>
  );
});
